import * as React from 'react';
/**
 *
 * Original name: rotate left
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1066
 *
 */
export const RotateLeftLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 5.5c-2.557 0-4.085.862-5 1.879V5.5H5.5V10H10V8.5H8.027C8.85 7.51 10.177 7 12 7c3.364 0 5 1.636 5 5s-1.636 5-5 5a5.894 5.894 0 0 1-3.108-.729l-.787 1.279A7.35 7.35 0 0 0 12 18.5c4.192 0 6.5-2.308 6.5-6.5 0-4.191-2.308-6.5-6.5-6.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
